export default "__VITE_ASSET__DEHyvHjf__"